import jQuery from "jquery";
import clamp from "clamp-js";

(function ($) {
    const debounce = (func, delay) => {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const $articleTitles = $(".article-title");

    const clampArticleTitles = () => {
        $articleTitles.each((_, element) => {
            clamp(element, { clamp: 2 });
        });
    };

    if ($articleTitles.length) {
        clampArticleTitles();
        $(window).on("resize", debounce(clampArticleTitles, 200));
    }

    const $moreBlogsTitles = $(".more-blogs-title");

    const clampMoreBlogsTitles = () => {
        $moreBlogsTitles.each((_, element) => {
            clamp(element, { clamp: 3 });
        });
    };

    if ($moreBlogsTitles.length) {
        clampMoreBlogsTitles();
        $(window).on("resize", debounce(clampMoreBlogsTitles, 200));
    }
})(jQuery);
